import { useEffect } from 'react';

/**
 * This page handles the WordPress Application Password callback.
 * WordPress redirects here with user_login and password params.
 * We send these back to the parent window via postMessage.
 */
export default function AuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userLogin = params.get('user_login');
    const password = params.get('password');

    if (userLogin && password && window.opener) {
      // Send credentials back to parent window
      window.opener.postMessage({
        type: 'wp-auth-success',
        username: userLogin,
        password: password,
      }, window.location.origin);

      // Close this popup after a short delay
      setTimeout(() => {
        window.close();
      }, 500);
    } else if (!window.opener) {
      // If opened directly (not as popup), redirect to dashboard
      window.location.href = '/';
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Completing authorization...</p>
        <p className="text-sm text-gray-400 mt-2">This window will close automatically.</p>
      </div>
    </div>
  );
}
